import HomeUserTabs from './HomeUserTabs';

export default HomeUserTabs;
